import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useCopy, useLang } from "@/contexts/LanguageContext";

const COPY = {
  en: { h: "Facilitator workspace", p: "Assist borrowers with profile completion and applications, subject to their authorisation.", untitled: "Untitled business", readiness: "Readiness", completion: "Completion", none: "No borrowers assigned." },
  hi: { h: "सुविधाकर्ता कार्यक्षेत्र", p: "उधारकर्ताओं की अनुमति से प्रोफ़ाइल पूर्ण करने और आवेदनों में सहायता करें।", untitled: "अनाम व्यवसाय", readiness: "तत्परता", completion: "पूर्णता", none: "कोई उधारकर्ता नहीं सौंपा गया।" },
};

export default function FacilitatorDashboard() {
  const [businesses, setBusinesses] = useState([]);
  const c = useCopy(COPY);
  const { tv } = useLang();
  useEffect(() => { api.get("/businesses").then((r) => setBusinesses(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="facil-dashboard">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{c.h}</h1>
        <p className="text-slate-600 mt-1 text-sm">{c.p}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {businesses.map((b) => (
          <div key={b.id} className="p-6 rounded-lg border border-slate-200 bg-white card-hover" data-testid={`facil-biz-${b.id}`}>
            <div className="font-semibold text-slate-900 brand-heading">{b.business_identity?.legal_business_name || c.untitled}</div>
            <div className="text-xs text-slate-500">{b.business_identity?.district} · {tv(b.business_identity?.industry)}</div>
            <div className="mt-3 text-xs">{c.readiness}: <span className="font-semibold">{b.readiness_band ? tv(b.readiness_band) : "—"}</span></div>
            <div className="mt-1 text-xs">{c.completion}: <span className="font-semibold">{b.profile_completion || 0}%</span></div>
          </div>
        ))}
        {businesses.length === 0 && <div className="text-sm text-slate-500">{c.none}</div>}
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
